import { Box, Flex, Image, Text } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import Card from 'components/_core/Card';
import Heading from 'components/_core/Heading';
import { OBCircleStatus, OBList } from 'features/Bento/components';

import RichText from '../../../Bento/atoms/RichText';
import { GetEpAgreementWallContextQuery } from '../../graphql/queries/getEpAgreementWallContext.gql';
import Illustration from './assets/Balloon.svg';
import getHasMissingInformation from './getHasMissingInformation';
import locales from './locales';

interface IntroductionProps {
  moduleData: GetEpAgreementWallContextQuery;
  onNext: () => void;
}

/**
 * A page where the user can see the outstanding agreement and accept it.
 */
const Introduction = asBentoPage<IntroductionProps>(
  ({ Layout, moduleData, onNext }) => {
    const hasMissingInformation = getHasMissingInformation(moduleData);

    return (
      <Layout>
        <Card gap="space-32" marginTop="space-32" size="lg">
          <Image alignSelf="center" src={Illustration} />

          <Box>
            <Heading>{locales.cardTitle}</Heading>

            <Text>{locales.cardDescription}</Text>
          </Box>

          <Flex flexDirection="column" gap="space-24">
            <Heading size="sm">{locales.listTitle}</Heading>

            <OBList>
              <OBList.Item>
                <OBCircleStatus alignSelf="center" size="sm" status="success" />

                <RichText>
                  {hasMissingInformation
                    ? locales.missingInformation
                    : locales.newCgu}
                </RichText>
              </OBList.Item>

              <OBList.Item>
                <OBCircleStatus alignSelf="center" size="sm" status="success" />

                <RichText>{locales.newIban}</RichText>
              </OBList.Item>
            </OBList>

            <Callout>
              <Callout.Content>{locales.callout}</Callout.Content>
            </Callout>
          </Flex>

          <Button
            alignSelf="center"
            isExpanded
            marginTop="space-8"
            onClick={onNext}
          >
            {hasMissingInformation
              ? locales.ctaWithMissingInformation
              : locales.cta}
          </Button>
        </Card>
      </Layout>
    );
  },
);

export default Introduction;
